import { reactive } from "vue";
import pmsService from "@/services/pmsService";
import eventi from "@/services/eventi";
import permessiService from "@/services/permessiService";

/**
 * Quanti messaggi degli ospiti restano da leggere: il numerino sulla voce di menu.
 *
 * Lo stato sta qui e non nel componente perche' il menu viene montato una volta per ogni
 * disposizione della pagina: tenendolo dentro, due menu avrebbero due conteggi diversi e
 * ognuno interrogherebbe il server per conto suo.
 *
 * Si aggiorna quando il server annuncia un messaggio, non chiedendo a intervalli. Il
 * ripiego lento c'e' lo stesso, per il caso in cui il canale sia giu'.
 */
export const statoMessaggi = reactive({ conteggio: 0 });

let disiscrivi = [];
let ripiego = null;
// Le risposte possono arrivare in disordine: quella di una lettura partita prima di "segnata letta" riaccenderebbe il
// numerino. Vale solo l'ultima domanda fatta.
let ultimaDomanda = 0;
/** Chi guarda una conversazione lo dice qui: vedi guarda(). */
let staGuardando = null;
/** Se il messaggio annunciato poi non diventa letto, il numerino si accende lo stesso: dopo questa attesa si rilegge. */
const ATTESA_DI_CHI_GUARDA_MS = 1500;

async function aggiorna() {
  const domanda = ++ultimaDomanda;
  try {
    // SOLO A CHI I MESSAGGI LI PUO' APRIRE, nel sito come nell'app.
    //
    // Il conteggio sta nell'area MESSAGGI (MappaAree: /api/v1/pms/conversations), che
    // proprietario e governante non hanno. Per loro la richiesta torna 403 AREA_NON_CONSENTITA:
    // chiederlo lo stesso vorrebbe dire un rifiuto a ogni avvio, ogni dieci minuti e a ogni
    // riapertura del canale, e finche' api.js rimandava alla pagina iniziale a ogni 403 il
    // proprietario veniva portato via dal calendario ogni volta.
    //
    // Il controllo sta qui e non in chi chiama avvia(), perche' i chiamanti sono quattro (main.js,
    // due volte secondo-fattore.vue, il guscio) e il ripiego e il «riconnesso» passano tutti da
    // qui. Senza ruolo (nessuno spazio) si chiede, come fa il server, che in quel caso lascia
    // passare.
    const ruolo = await permessiService.ruolo();
    if (!permessiService.puoAprire(ruolo, "/messages")) {
      statoMessaggi.conteggio = 0;
      return;
    }
    const conteggio = await pmsService.getUnreadCount();
    if (domanda === ultimaDomanda) statoMessaggi.conteggio = conteggio;
  } catch (e) {
    // Se la distribuzione non e' attiva l'endpoint non esiste: nessun numerino, ed e'
    // giusto cosi'. Non e' un errore da mostrare.
    statoMessaggi.conteggio = 0;
  }
}

export default {
  avvia() {
    if (disiscrivi.length) return;
    aggiorna();
    // Solo i messaggi nuovi cambiano il conteggio. Le altre voci dell'annuncio WhatsApp (spunte,
    // reazioni, media arrivati dopo, modifiche, cancellazioni, cambio di chiave della chat) no: il
    // server conta i messaggi dell'ospite non letti, cancellati compresi, e rileggerlo a ogni spunta
    // vorrebbe dire una richiesta per ogni cambio di stato di ogni invio. Un annuncio senza cambio
    // (OTA di prima, push locale di notifichePush) vale come nuovo.
    // "letta": qualcuno ha letto, anche da un altro schermo o un altro utente. Il numerino si spegne per tutti, come su WhatsApp.
    disiscrivi.push(eventi.su("messaggio", (d) => {
      if (d?.cambio === "letta") {
        aggiorna();
      } else if (!d?.cambio || d.cambio === "nuovo") {
        // Un messaggio della conversazione che si sta guardando diventa letto da solo: accendere il numerino
        // per un attimo vorrebbe dire una notifica di una cosa che si ha davanti agli occhi.
        if (staGuardando?.(d)) setTimeout(aggiorna, ATTESA_DI_CHI_GUARDA_MS);
        else aggiorna();
      }
    }));
    disiscrivi.push(eventi.su("riconnesso", aggiorna));
    ripiego = setInterval(() => {
      if (!document.hidden) aggiorna();
    }, 600000);
  },

  ferma() {
    disiscrivi.forEach((f) => f());
    disiscrivi = [];
    if (ripiego) {
      clearInterval(ripiego);
      ripiego = null;
    }
  },

  /** Da chiamare quando si legge una conversazione, per non aspettare il prossimo annuncio. */
  aggiorna,

  /**
   * La pagina dei messaggi dice come sapere se un annuncio riguarda la conversazione che si ha davanti: (annuncio) => vero o
   * falso. Nulla quando la pagina se ne va.
   */
  guarda(funzione) {
    staGuardando = funzione;
  },
};
